import { render, staticRenderFns } from "./NextMentorias.vue?vue&type=template&id=990837be&scoped=true&"
import script from "./NextMentorias.vue?vue&type=script&lang=js&"
export * from "./NextMentorias.vue?vue&type=script&lang=js&"
import style0 from "./NextMentorias.vue?vue&type=style&index=0&id=990837be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990837be",
  null
  
)

export default component.exports